import { type GenericMap, SystemColor } from "@common/declarations";
import classNames from "classnames";
import { sortBy } from "lodash";
import React from "react";
import TimelineGroup from "./Group";
import TimelineItem from "./Item";
import { groupByDate } from "./lib";
import "./style.less";

export interface TimelineItemInfo {
  id?: string;
  icon?: any;
  title: any;

  content?: any;
  date: Date | string;

  addon?: any;
  attachments?: TimelineAttachment[];
  className?: string;
  color?: SystemColor | null;
  isDateHidden?: boolean;
  onClick?: () => void;
}

export interface TimelineAttachment {
  name: string;
  url: string;
}

export interface TimelineProps {
  className?: string;
  hasLine?: boolean;
  isDateHidden?: boolean;
  items: TimelineItemInfo[];
  dontSort?: boolean;
}

const Timeline = (props: TimelineProps) => {
  const items = React.useMemo(
    () => (props.dontSort ? props.items : sortBy(props.items, (x) => new Date(x.date))),
    [props.items, props.dontSort]
  );
  return (
    <ul
      className={classNames(props.className, "timeline", {
        icon: props.items.some((x) => !!x.icon)
      })}
      style={{ "--line-color": props.hasLine ? "#eee" : "transparent" } as any}
    >
      {items.map((x, index) => (
        <TimelineItem key={index} tag="li" item={x} />
      ))}
    </ul>
  );
};

export default Timeline;

export type TimelineGrouppedProps = TimelineProps;
export const TimelineGroupped = (props: TimelineGrouppedProps) => {
  const groups = React.useMemo((): GenericMap<TimelineItemInfo[]> => groupByDate(props.items), [props.items]);

  return (
    <ul
      className={classNames("timeline groupped", {
        icon: props.items.some((x) => !!x.icon)
      })}
      style={{ "--line-color": props.hasLine ? "#eee" : "transparent" } as any}
    >
      {Object.keys(groups).map((d, index) => (
        <TimelineGroup key={index} createdOnDate={d} items={groups[d]} isDateHidden={props.isDateHidden} />
      ))}
    </ul>
  );
};
